import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Modal as UiKitModal } from '@gamesb42/ui-kit';

import urls from 'constants/urls';
import { KeyTransactions } from 'components/tables/TransactionsTable/data';
import { activationOrderDataType } from 'hooks/api/useActivationOrder';

import { buildDefaultInterestPrefill, getOutstandingDefaultInterest } from './defaultInterest';

// Пока DI не погашен, principal не гасим: предлагаем создать транзакцию на DI
const useDefaultInterestGuard = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return useCallback(
    (activationOrderData?: Partial<activationOrderDataType> | null, currency?: string | null): boolean => {
      const defaultInterest = getOutstandingDefaultInterest(activationOrderData, currency);

      if (!defaultInterest || !activationOrderData) return false;

      UiKitModal.warning({
        title: t('forms.activationOrder.outstandingDefaultInterest'),
        okText: t('forms.activationOrder.createTransaction'),
        cancelText: t('forms.transaction.cancel'),
        onOk: () =>
          history.push({
            pathname: `${urls.getTransactionsCreate()}/${KeyTransactions.INTERNAL}`,
            state: { transactionPrefill: buildDefaultInterestPrefill(activationOrderData, defaultInterest) },
          }),
        onCancel: () => {},
      });

      return true;
    },
    [history, t],
  );
};

export default useDefaultInterestGuard;
